import type { Routes } from '@angular/router';
import { privateGuard } from '@/app/core/guards/private-guard';
import { publicGuard } from '@/app/core/guards/public-guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [publicGuard],
    loadComponent: () => import('@/app/layouts/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: 'login',
        loadComponent: () => import('@/app/features/auth/pages/login/login').then((m) => m.Login),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
  {
    path: '',
    canActivateChild: [privateGuard],
    loadComponent: () => import('@/app/layouts/main-layout/main-layout').then((m) => m.MainLayout),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('@/app/features/dashboard/pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'monitoring-panel',
        loadComponent: () => import('@/app/features/monitoring-panel/pages/monitoring-panel/monitoring-panel').then((m) => m.MonitoringPanel),
      },
      {
        path: 'monitoring-panel2',
        loadComponent: () => import('@/app/features/monitoring-panel/pages/monitoring-panel2/monitoring-panel').then((m) => m.MonitoringPanel),
      },
      {
        path: 'alarm-log',
        loadChildren: () => import('@/app/features/alarm-log/alarm-log.routes').then((m) => m.ALARM_LOG_ROUTES),
      },
      {
        path: 'device-management',
        loadChildren: () => import('@/app/features/device-management/device-management.routes').then((m) => m.DEVICE_MANAGEMENT_ROUTES),
      },
      {
        path: 'maintenance-management',
        loadChildren: () => import('@/app/features/maintenance-management/maintenance-management.routes').then((m) => m.MAINTENANCE_MANAGEMENT_ROUTES),
      },
      {
        path: 'system-management',
        loadChildren: () => import('@/app/features/system-management/system-management.routes').then((m) => m.SYSTEM_MANAGEMENT_ROUTES),
      },
      {
        path: 'notification-management',
        loadChildren: () => import('@/app/features/notification-management/notification-management.routes').then((m) => m.NOTIFICATION_MANAGEMENT_ROUTES),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  {
    path: '',
    loadComponent: () => import('@/app/layouts/empty-layout/empty-layout').then((m) => m.EmptyLayout),
    children: [
      {
        path: '**',
        loadComponent: () => import('@/app/features/errors/pages/not-found/not-found').then((m) => m.NotFound),
      },
    ],
  },
];
